import { css } from 'styled-components';

const StandardBottomMargin = css`
  margin-bottom: ${(props) => props.theme.spacing(12)};
`;

export default StandardBottomMargin;
